import { to_array } from "./to_array"

export const apply = (f, args) => f.apply(null, to_array(args))
